import { DWH265playerVideo } from 'src/components/h265player-video';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWH265playerVideo.displayName, DWH265playerVideo);

export default DWH265playerVideo;
export { DWH265playerVideo };
